import { combineReducers } from "redux";

import { persistReducer } from "redux-persist";
import storageSession from "redux-persist/lib/storage/session";
import appointmentReducer from "./appointment";
import xAppointmentReducer from "./xAppointment";
import o2AppointmentReducer from "./o2Appointment";
import appointmentBookingReducer from "./appointmentBooking";
import servicesReducer from "./services";
import signPassIdentifyReducer from "./signPassIdentify";
import headerReducer from "./header";
import LoadingReducer from "./loading";

const persistConfig = {
  key: "root",
  storage: storageSession,
  whitelist: [
    "appointment",
    "appointmentBooking",
    "xAppointment",
    "o2Appointment",
    "services",
    "signPassIdentify",
    "header",
    "loading"
  ]
};

const rootReducer = combineReducers({
  appointment: appointmentReducer,
  appointmentBooking: appointmentBookingReducer,
  xAppointment: xAppointmentReducer,
  o2Appointment: o2AppointmentReducer,
  services: servicesReducer,
  signPassIdentify: signPassIdentifyReducer,
  header: headerReducer,
  loading: LoadingReducer
});

export default persistReducer(persistConfig, rootReducer);
